import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '@/views/account/redux/action';
import PurchaseRender from './children/PurchaseRender';
import purchaseList from '@/views/account/constants/purchase';
import {
  requsetGetPurchase,
  requsetGetSubscription,
} from '@/views/account/api/apis';
import { GAPurchasePageDisplay } from '@/views/account/ga/purchase';
import '@/views/account/assets/purchase.scss';
import Utils from '@/utils/utils';
import cartUrl from '@/views/account/utils/cartUrl';
class Purchase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currPackage: null, //选中的套餐：month | year | week
      packageMap: purchaseList,
    };
    this.timer = null;
    this.urlParam = {};
  }

  componentDidMount() {
    console.log('进来');
    // eslint-disable-next-line no-restricted-globals
    if (location.href.indexOf('track[type]') >= 0) {
      // eslint-disable-next-line no-restricted-globals
      const urlParam = this.getUrlParam(location.href);
      this.urlParam = urlParam;
    } else {
      const track = cartUrl('');
      let obj = {};
      Object.keys(track).map((v) => {
        const objName = `track[${v}]`;
        obj[objName] = `${track[v]}`;
      });
      this.urlParam = obj;
    }
    GAPurchasePageDisplay();
  }

  componentWillUnmount() {
    //清除定时器
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  getUrlParam = (url) => {
    // 通过 ? 分割获取后面的参数字符串
    let urlStr = url.split('?')[1];
    // 创建空对象存储参数
    let obj = {};
    // 再通过 & 将每一个参数单独分割出来
    let paramsArr = urlStr.split('&');
    for (let i = 0, len = paramsArr.length; i < len; i++) {
      // 再通过 = 将每一个参数分割为 key:value 的形式
      let arr = paramsArr[i].split('=');
      obj[arr[0]] = arr[1];
    }
    return obj;
  };

  //判断当前是否需要轮询订阅信息，如果需要就轮询
  handleListenerSubscription = () => {
    const urlParams = new URLSearchParams(this.props.urlSearch);
    const redirect = urlParams.get('redirect');
    const to = urlParams.get('to');
    if (redirect && to === 'purchase') {
      console.log('需要轮训');
      this.timer = setInterval(() => {
        requsetGetSubscription()
          .then((res) => {
            if (res.code === 200) {
              if (res.data.subscription != null) {
                let result = res.data.subscription.filter((item) => {
                  return item.product_name == 'HitPaw Online';
                });
                if (result.length > 0) {
                  if (result[0].status != 'Expired') {
                    console.log('监听到了用户已经购买');
                    this.props.onPurchaseModalObjChange({
                      ...this.props.purchaseModalObj,
                      visible: false,
                    });
                  }
                }
              }
              this.props.onSubscriptionChange(res.data.subscription);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }, 12000);
    }
  };

  /**
   *请求跳转购物车地址
   * @param {string} plan  month | year
   * @param {string} site  en | de | es | fr | jp | br | ru | ar | it | tr | nl | id | in | kr
   */
  handleGetPurchaseURL = (plan) => {
    const site = Utils.getLanguage() || 'en';
    this.setState({
      currPackage: plan,
    });
    const formData = new FormData();
    formData.append('plan', plan);
    formData.append('site', site);
    requsetGetPurchase({
      body: formData,
    })
      .then((res) => {
        console.log(res);
        if (res.code === 200) {
          //轮询监听用户购买
          this.handleListenerSubscription();
          //购物车地址
          let cycle = '';
          if (plan === 'month') {
            cycle = `2`;
          } else if (plan === 'year') {
            cycle = `3`;
          } else {
            cycle = `1`;
          }
          let cartUrl = res.data.cart_url;
          cartUrl =
            cartUrl +
            `&track[type]=${this.urlParam['track[type]']}&track[sid]=${this.urlParam['track[sid]']}&track[func]=${this.urlParam['track[func]']}&track[reason]=${this.urlParam['track[reason]']}&track[host]=${this.urlParam['track[host]']}&track[platform]=${this.urlParam['track[platform]']}&track[cycle]=${cycle}&track[ab]=${this.urlParam['track[ab]']}&track[channel]=${this.urlParam['track[channel]']}&track[discount]=${this.urlParam['track[discount]']}`;
          window.open(cartUrl, '_blank');
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          currPackage: null,
        });
      });
  };

  render() {
    return (
      <div className='purchase-page overflow-hidden'>
        <PurchaseRender
          packageMap={this.state.packageMap}
          currPackage={this.state.currPackage}
          handleGetPurchaseURL={this.handleGetPurchaseURL}
        />
      </div>
    );
  }
}

const mapStateToPropos = (state) => ({
  profileObj: state.account.profileObj,
  subscription: state.account.subscription,
  authorization: state.account.authorization,
});
const mapDispatchToProps = (dispatch) => ({
  onProfileObjChange: (profileObj) =>
    dispatch(actions.onProfileObjChange(profileObj)),
  onAuthorizationChange: (authorization) =>
    dispatch(actions.onAuthorizationChange(authorization)),
  onSubscriptionChange: (subscription) =>
    dispatch(actions.onSubscriptionChange(subscription)),
});

export default connect(mapStateToPropos, mapDispatchToProps)(Purchase);
